import React from 'react'

export const AppErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div className="min-h-screen bg-red-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-lg w-full p-6">
        <div className="flex items-center mb-4">
          <div className="bg-red-100 rounded-full p-3 mr-4">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-red-800">Application Error</h1>
        </div>
        
        <p className="text-gray-700 mb-4">
          {import.meta.env.DEV ? error.message : 'Something went wrong. Please try again.'}
        </p>
        
        {import.meta.env.DEV && error.stack && (
          <pre className="bg-gray-100 p-4 rounded mb-4 overflow-auto text-sm">
            {error.stack}
          </pre>
        )}
        
        <button
          onClick={resetErrorBoundary}
          className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  )
}

export const FeatureErrorFallback = ({ error, resetErrorBoundary, featureName }) => {
  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 m-4">
      <div className="flex items-center mb-2">
        <svg className="w-5 h-5 text-yellow-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <h3 className="font-semibold text-yellow-800">{featureName} encountered an error</h3>
      </div>
      
      <p className="text-sm text-yellow-700 mb-3">
        {import.meta.env.DEV ? error.message : 'This feature is temporarily unavailable'}
      </p>
      
      <button
        onClick={resetErrorBoundary}
        className="text-sm bg-yellow-600 text-white px-3 py-1 rounded hover:bg-yellow-700"
      >
        Retry
      </button>
    </div>
  )
}